// Funções de validação de documentos

export const validateCPF = (cpf) => {
  // eslint-disable-next-line no-useless-escape
  let regexCPF = /[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}/;

  if (!new RegExp(regexCPF).test(cpf)) return false;

  let regexOnlyNumbers = /^[0-9]+$/;

  if (!new RegExp(regexOnlyNumbers).test(cpf)) cpf = cpf.replace(/\D/g, "");

  let soma;
  let resto;

  soma = 0;
  if (cpf === "00000000000") return false;

  for (let i = 1; i <= 9; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;

  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;

  soma = 0;
  for (let i = 1; i <= 10; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;

  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(10, 11))) return false;

  return true;
};

export const validateCNPJ = (cnpj) => {
  cnpj = cnpj.replace(/[^\d]+/g, "");

  if (cnpj === "") {
    return false;
  }

  if (cnpj.length !== 14) {
    return false;
  }

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj === "00000000000000" ||
    cnpj === "11111111111111" ||
    cnpj === "22222222222222" ||
    cnpj === "33333333333333" ||
    cnpj === "44444444444444" ||
    cnpj === "55555555555555" ||
    cnpj === "66666666666666" ||
    cnpj === "77777777777777" ||
    cnpj === "88888888888888" ||
    cnpj === "99999999999999"
  ) {
    return false;
  }

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(0))) {
    return false;
  }

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(1))) {
    return false;
  }

  return true;
};

export const validatePartitaIVA = (pi) => {
  if (pi === "") return false;
  else if (!/^[0-9]{11}$/.test(pi)) return false;
  else {
    var s = 0;
    for (let i = 0; i <= 9; i += 2) {
      s += parseInt(pi.charCodeAt(i) - "0".charCodeAt(0));
    }
    for (let i = 1; i <= 9; i += 2) {
      var c = 2 * parseInt(pi.charCodeAt(i) - "0".charCodeAt(0));
      if (c > 9) c = c - 9;
      s += c;
    }
    var controllo = (10 - (s % 10)) % 10;
    if (controllo !== parseInt(pi.charCodeAt(10) - "0".charCodeAt(0))) return false;
    else return true;
  }
};

export const validateCodiceFiscale = (cfins) => {
  let cf = cfins.toUpperCase();
  let cfReg = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/;

  if (!cfReg.test(cf)) {
    return false;
  }

  let set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
  let s = 0;

  for (let i = 1; i <= 13; i += 2) {
    s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
  }

  for (let i = 0; i <= 14; i += 2) {
    s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
  }

  if (s % 26 !== cf.charCodeAt(15) - "A".charCodeAt(0)) {
    return false;
  }

  return true;
};

export const validatePhoneNumber = (phone) => {
  // Remove todos os caracteres não numéricos
  const cleanPhone = phone.replace(/\D/g, "");

  // Validação básica: deve ter entre 8 e 15 dígitos
  if (cleanPhone.length < 8 || cleanPhone.length > 15) {
    return false;
  }

  // Validação adicional para números brasileiros (se começar com código do país +55 ou 55)
  if (cleanPhone.startsWith("55") && cleanPhone.length >= 12 && cleanPhone.length <= 13) {
    return true;
  }

  // Validação para números italianos (começam com 39 ou +39)
  if (cleanPhone.startsWith("39") && cleanPhone.length >= 11 && cleanPhone.length <= 13) {
    return true;
  }

  // Validação genérica para números locais
  if (cleanPhone.length >= 8 && cleanPhone.length <= 11) {
    return true;
  }

  return true; // Aceita outros formatos internacionais
};

